import React, { FC } from 'react';
import { ButtonStroke } from '@blink/components';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SubmitIcon } from '@blink/assets/src/icons/submit.svg';
import { ReactComponent as ArrowIcon } from '@blink/assets/src/icons/arrowBtn.svg';

import { usePersonalisedPoolSuccessStyle } from './PersonalisedPoolSuccess.style';
import { PATHS } from 'src/routes/paths';

export const PersonalisedPoolSuccess: FC = () => {
    const classes = usePersonalisedPoolSuccessStyle();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(PATHS.HOME);
    };

    return (
        <div className={classes.layout}>
            <div className={classes.content}>
                <div className={classes.icon}>
                    <SubmitIcon />
                </div>

                <div className={classes.container}>
                    <div className={classes.top}>
                        <span className={classes.title}>Your Pool Request Has Been Submitted!</span>
                        <span className={classes.note}>
                            An email confirmation has been sent to operations@arkis.xyz. Our team is
                            currently reviewing your details, and we will reach out if further
                            information is needed
                        </span>
                    </div>
                    <div className={classes.bottom}>
                        <span className={classes.note}>
                            If you don’t get the email soon, check your spam folder
                        </span>
                        <div>
                            <span className={classes.note}>Still need help?</span>
                            <a href={`mailto:operations@arkis.xyz`}>Contact our Arkis Admin</a>
                        </div>
                    </div>
                </div>

                <ButtonStroke isPrimary onClick={handleClick} className={classes.btn}>
                    <ArrowIcon />
                    Back to the dashboard
                </ButtonStroke>
            </div>
        </div>
    );
};
